export const mdpMeetingSchema = {
	title: 'MDP Meeting schema',
	description: 'MDP Meeting Schema',
	version: 0,
	primaryKey: 'id',
	type: 'object',
	properties: {
		id: {
			type: 'string',
			maxLength: 250,
		},
		sfid: {
			type: 'string',
			maxLength: 250,
		},
		mdicode_c: {
			type: ['string', 'null'],
		},
		rbdmcode_c: {
			type: ['string', 'null'],
		},
		meeting_type_c: {
			type: ['string', 'null'],
		},
		cmditownlist_c: {
			type: ['string', 'null'],
		},
		name: {
			type: ['string', 'null'],
		},
		number_of_planned_meetings_c: {
			type: 'number',
		},
		actual_number_of_planned_meetings_c: {
			type: 'number',
		},
		participantspermeeting_c: {
			type: ['string', 'null'],
		},
		monthname_c: {
			type: ['string', 'null'],
		},
		plan_budget_c: {
			type: ['string', 'null'],
		},
		financial_year_c: {
			type: ['string', 'null'],
		},
		town_c: {
			type: ['string', 'null'],
		},
		createddate: {
			type: 'string',
			format: 'date-time',
		},
	},
	required: [
		'id',
		'sfid',
		'mdicode_c',
		'rbdmcode_c',
		'meeting_type_c',
		'cmditownlist_c',
		'name',
		'number_of_planned_meetings_c',
		'actual_number_of_planned_meetings_c',
		'participantspermeeting_c',
		'monthname_c',
		'plan_budget_c',
		'town_c',
		'financial_year_c',
		'createddate',
	],
};
